
import Panel from 'vux/src/components/panel/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import headerBackTitle from '@/components/header/headerBackTitle'
import compentList from '@/crowd_fund/compentList'
const list = () => ['机构简介', '机构证书', '管理项目']
export default {
components: {
headerBackTitle,
Panel,
Tab,
TabItem,
Swiper,
SwiperItem,
compentList
},
data () {
return {
org_project_size:'0',
org_data:{},//三个数
org_user_id:'',//申请机构人的userid
org_detail:{}, //详情数据
org_parject_list:[],//项目列表
list: [{
src: './static/appimg/ylbf_logo.png',
fallbackSrc: 'http://placeholder.qiniudn.com/60x60/3cc51f/ffffff',
title: '中国社会福利基金会',
desc: '已在民政部门注册有公募资格的慈善机构<br> 联系电话：15468954926',

}],

list2: list(),
demo1: '机构简介',
index: 0,
height:0,
icon:false
}
},
methods:{
ishide () {
if(this.icon == false){
this.icon = true
}else{
this.icon = false
}
},
project_height(){

this.height=window.innerHeight-(this.$refs.scroll.offsetTop)
console.log('-----*********',this.height)
},
refresh(done){
this.getfqList(done)
},
infinite(){
console.log('到底了')
},
getfqList(done){
let data={
afa115:this.org_user_id,
pageSize:10,
pageIndex:0,
}
this.$https.post(this.BASE_URL+"cfs/ajaxpagequery/zc/z015/getfqList",this.qs.stringify(data),{
headers: {
'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}
})
.then(res => {
this.org_parject_list = res.data.result.pageresult.data;
this.org_project_size=res.data.result.pageresult.size;
if(done){
done()
}
})
.catch(function(err) {
console.log(err);
})
},

org_detailFn(){
this.list=[
{
src: this.org_detail.organ_logo,
fallbackSrc: 'http://placeholder.qiniudn.com/60x60/3cc51f/ffffff',
title: this.org_detail.org_name,
desc:  '已在民政部门注册有公募资格的慈善机构<br> 联系电话：'+this.org_detail.org_tel,
}
]
},

getDetailssss(){
let data={
id: this.org_user_id
}
this.$https.post(this.BASE_URL+"uts/organization/queryOrganizationInfo",
this.qs.stringify(data),
{
headers: {
'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}
}
)
.then(res => {
this.org_detail = res.data.data;
this.org_detailFn()
console.log(res.data,'22222222222222222222');
})
.catch(function(err) {
console.log(err);
})
},

getgmxqList(){
let data={
afa115:this.org_user_id
}
this.$https.post(this.BASE_URL+"cfs/ajaxpagequery/zc/z015/getgmxqList",this.qs.stringify(data),
{
headers: {
'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}
}
)
.then(res => {
this.org_data = res.data.result.pageresult.data[0];
console.log(res.data,'111111111111111111111122222222222');

})
.catch(function(err) {
console.log(err);
})
},

},
computed:{

},
mounted(){
this.org_user_id=this.$route.params.org_user_id
this.zcnickname = this.$route.params.zcnickname
this.zcuserid = this.$route.params.zcuserid
this.zctoken = this.$route.params.zctoken
console.log(this.zctoken,'qqqqqqqqqqqqq')
this.project_height()
this.getfqList()
this.getgmxqList()
this.getDetailssss();
},
destroyed(){

}
}



// WEBPACK FOOTER //
// ./src/crowd_fund/organDetails.vue